// `GlobalSearch.tsx`'s `window` CustomEvent name (story 2-129 — universal
// search, D42) — extracted by story 2-147wg (leaf-component/registry
// closure sweep) for the same reason `agentEvents.ts` was: a pure
// event-name string with zero React/JSX dependency, so `TopBar.tsx`
// (layout-primitive) can import it directly instead of reaching up into
// `GlobalSearch.tsx` (composite) — closing a real `design-language/
// no-upward-import` finding with an actual architectural fix, not a new
// `UPWARD_IMPORT_ALLOWLIST` entry (forbidden by this story's own Mandatory
// Migration Rules). `GlobalSearch.tsx` re-exports it for its own internal
// use and any other existing consumer.
export const OPEN_SEARCH_EVENT = 'sitewise:open-search';
